<div class="sidecontent-option-container" [ngSwitch]="displayedContent" >
  <mat-toolbar class="sidemenu-toolbar p-0 gap-0">
    <button mat-icon-button class="example-icon" (click)="onBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span *ngIf="displayedContent == 'promtStatus'" class="title">{{ 'Status' | titlecase }}</span>
    <ng-container *ngIf="displayedContent == 'addComponent'" >
    <span class="title">{{ 'Add Component' | titlecase}}</span>
  </ng-container>
  <ng-container *ngIf="displayedContent == 'modifyPage'">
    <span class="title">{{ 'Add Page' | titlecase}}</span>
  </ng-container>
  <ng-container *ngIf="displayedContent == 'widget'">
    <span class="title">{{ selectedWidgetMetaData?.widgetLabel+ " " + "Properties" || 'widget' | titlecase }}</span>
  </ng-container>
  <ng-container *ngIf="displayedContent == 'stage'">
    <span class="title">{{ stageName + 'Stage Configuration' | titlecase }}</span>
  </ng-container>
  </mat-toolbar>

  <div class="scroll-container">

    <ng-container *ngSwitchCase="'addComponent'">
      <mat-form-field class="w-100 rounded-0 mat-no-hint">
        <mat-label>Search Component</mat-label>
        <input matInput type="text" [(ngModel)]="searchTerm" (ngModelChange)="applyFilter()">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
      <mat-accordion displayMode="flat" togglePosition="before" [multi]="isFilterApplied">
        <mat-expansion-panel *ngFor="let category of filteredCategories; let i = index" [expanded]="panelStates[i]">
          <mat-expansion-panel-header>
            <mat-panel-title class="m-0">
              <span class="flex-fill">{{category.type}}</span>
              <mat-chip>{{category.items.length}}</mat-chip>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row g-2" cdkDropList [cdkDropListData]="category.items" cdkDropListSortingDisabled="true"  (cdkDropListDropped)="drop($event)">
            <div class="col-4" *ngFor="let item of category.items; let j = index;trackBy: trackByFn" cdkDrag>
              <mat-card class="mat-custom-card-sm mat-card-component" 
                >
                <mat-card-content class="p-1">
                  <div class="name">{{ item.name | titlecase}}</div>
                  <div class="icon">
                    <img [src]="getImageUrl(item)" [alt]="item.image + 'image'">
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>

    <ng-container *ngSwitchCase="'modifyPage'">
      <mat-form-field class="w-100 rounded-0">
        <mat-label>Search Page</mat-label>
        <input matInput type="text" [(ngModel)]="searchTerm" (ngModelChange)="applyFilter()">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
      <mat-accordion displayMode="flat" togglePosition="before" [multi]="isFilterApplied">
        <mat-expansion-panel *ngFor="let category of filteredDefaultPageTemplate; let i = index" [expanded]="panelStates[i]">
          <mat-expansion-panel-header>
            <mat-panel-title class="m-0">
              <span *ngIf="category.pageType.trim() === 'LoginPage'" class="flex-fill">{{ 'Login' | titlecase}}</span>
              <span *ngIf="category.pageType.trim() === 'ForgotPasswordPage'" class="flex-fill">{{ 'Forgot Password' | titlecase}}</span>
              <span *ngIf="category.pageType.trim() === 'ChangePasswordPage'" class="flex-fill">{{ 'Change Password' | titlecase}}</span>
              <span *ngIf="category.pageType.trim() === 'CustomPage'" class="flex-fill">{{ 'Custom Page' | titlecase}}</span>
              <mat-chip>{{category.items.length}}</mat-chip>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row g-2">
            <div class="col-6" *ngFor="let item of category.items">
              <mat-card class="mat-custom-card-sm mat-card-component" draggable="true"
                (dragstart)="onDragStart($event,item)" (dragend)="onDragEnd($event)">
                <mat-card-content>
                  <div class="name">{{ item.masterPageName | titlecase}}</div>
                  <div class="icon">
                    <img [src]="getPageImageUrl(item)" [alt]="item.icon + 'image'">
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>
    <ng-container *ngSwitchCase="'widget'">
      <lib-widget-property-forms></lib-widget-property-forms>
    </ng-container>
    <ng-container *ngSwitchCase="'stage'">
      <lib-stage></lib-stage>
    </ng-container>
    <ng-container *ngSwitchCase="'promtStatus'" >
      <div class="disabled-message">
        Component disabled. Please enable the component to view properties.
      </div>
      
    </ng-container>
  </div>
  </div>
  